import { computed, onMounted, onUnmounted, ref } from '@vue/composition-api';
import { SyncConflictItemData } from '@/renderer/views/desktop/FileManagement/FileSync/composition/FileSyncUIDefine';
import { CoSyncCenterEvent } from '@/renderer/scripts/CoSync/SyncCenter/CoSyncCenterEvent';
import SyncCenter, { SyncTaskUIStatus } from '@/renderer/scripts/CoSync/SyncCenter/SyncCenter';
import { CoSyncStatus, SyncStatusConflictInfo } from '@/workerProcessRenderer/scripts/CoSyncEngine/common/CoSyncEvent';
import { syncCenterEventBus } from '@/renderer/scripts/CoSync/SyncCenter/SyncCenterEventBus';
import { coSync } from '@/renderer/scripts/CoSync/coSync';
import { CoSyncStrategy, getName } from '@/workerProcessRenderer/scripts/CoSyncEngine/common/CoSyncConfig';
import { CoSyncReporter } from '@/renderer/views/desktop/FileManagement/FileSync/composition/CoSyncReporter';

export default function useCoSyncConflictHandler() {
  const shouldShowConflictDrawer = ref(false);

  // 冲突的任务
  const conflictTask = ref<SyncTaskUIStatus[]>([]);
  // 冲突数量
  const conflictTaskCount = computed(() => conflictTask.value.length);

  const conflictListData = computed<SyncConflictItemData[]>(() => {
    // 数据源
    const retArray: SyncConflictItemData[] = [];
    conflictTask.value.forEach((element: SyncTaskUIStatus) => {
      if (element.statusInfo.status === CoSyncStatus.STATUS_CONFLICT) {
        const syncConflictInfo = element.statusInfo as SyncStatusConflictInfo;
        retArray.push({
          syncId: element.coSyncInfo.localSyncId,
          taskName: getName(element.coSyncInfo.config.syncPath),
          SyncStrategy: element.coSyncInfo.config.syncSetting.strategy,
          localRootPath: element.coSyncInfo.config.syncPath.localPath,
          remoteRootPath: element.coSyncInfo.config.syncPath.remotePath,
          spaceId: element.coSyncInfo.config.syncPath.spaceId,
          spaceOrgId: element.coSyncInfo.config.syncPath.spaceOrgId,
          conflictDataObj: syncConflictInfo.conflictData,
        });
      }
    });
    return retArray;
  });

  const methods = {
    // 展示冲突抽屉
    showConflictDialog() {
      shouldShowConflictDrawer.value = true;
      CoSyncReporter.getInstance().reportConflictDrawerShow();
    },
    closeConflictDialog() {
      shouldShowConflictDrawer.value = false;
    },
  };

  const onTaskStatusMapChange = (param?: Map<number, SyncTaskUIStatus>) => {
    let taskStatusMap = param;
    if (!taskStatusMap) {
      taskStatusMap = new Map<number, SyncTaskUIStatus>();
    }

    conflictTask.value = Array.from(taskStatusMap)
      .filter(
        ([taskId, status]: [number, SyncTaskUIStatus]) => status.statusInfo.status === CoSyncStatus.STATUS_CONFLICT,
      )
      .map(([taskId, status]: [number, SyncTaskUIStatus]) => status);
  };

  onMounted(() => {
    onTaskStatusMapChange(coSync.centerData().syncTaskStatusMap);
    syncCenterEventBus.on(CoSyncCenterEvent.onTaskStatusMapChange, onTaskStatusMapChange);
  });

  onUnmounted(() => {
    syncCenterEventBus.off(CoSyncCenterEvent.onTaskStatusMapChange, onTaskStatusMapChange);
  });

  return {
    shouldShowConflictDrawer,
    conflictTaskCount,
    conflictListData,
    methods,
  };
}
